import api from './api';

export const referralService = {
  // Get referral stats
  getStats: () => api.get('/referrals/stats'),

  // Get referral list
  getList: (params = {}) => api.get('/referrals/list', { params }),

  // Generate referral link
  getLink: () => api.get('/referrals/link'),

  // Process referral signup
  signup: (data) => api.post('/referrals/signup', data),

  // Get referrer by ID
  getReferrerById: (referralId) => api.get(`/referrals/referrer/${referralId}`),

  // Track referral click with phone number
  trackReferralClick: (referralId, phoneNumber) => api.post('/referrals/track', { referralId, phoneNumber }),
};
